export default __webpack_public_path__ + "static/media/SEEV_CMYK_LOGO.2092ae95.png";